export const TRANSLATIONS_KR = {
  academie: "academia",
  usage: "usegia",
  service: "servicia",
};
